import React from 'react';
import styled, { keyframes } from 'styled-components';
import { COLORS } from '../../themes';
var extendRight = /*#__PURE__*/keyframes(["40%,100%{width:100%;}"]);
var extendDown = /*#__PURE__*/keyframes(["30%{height:19.82%;}67%,100%{height:60.34%;}"]);
var moveUp = /*#__PURE__*/keyframes(["45%{top:39.66%;}70%,100%{top:0%;}"]);
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "figure-logo-animation__Wrapper",
  componentId: "sc-1da7e0c-0"
})(["position:relative;width:20vw;max-width:140px;height:33.14vw;max-height:232px;margin:0 auto 24px;opacity:0.7;transform:translateZ(0);div{position:absolute;top:39.66%;width:32.86%;height:19.82%;background-color:", ";border:1px solid ", ";}"], COLORS.PRIMARY_700, COLORS.PRIMARY_700);
var Top = /*#__PURE__*/styled.div.withConfig({
  displayName: "figure-logo-animation__Top",
  componentId: "sc-1da7e0c-1"
})(["animation:", " 1.75s infinite,", " 1.75s infinite;"], extendRight, moveUp);
var Middle = /*#__PURE__*/styled.div.withConfig({
  displayName: "figure-logo-animation__Middle",
  componentId: "sc-1da7e0c-2"
})(["animation:", " 1.75s infinite;"], extendRight);
var Bottom = /*#__PURE__*/styled.div.withConfig({
  displayName: "figure-logo-animation__Bottom",
  componentId: "sc-1da7e0c-3"
})(["animation:", " 1.75s infinite;"], extendDown);

var _ref2 = /*#__PURE__*/React.createElement(Top, null);

var _ref3 = /*#__PURE__*/React.createElement(Middle, null);

var _ref4 = /*#__PURE__*/React.createElement(Bottom, null);

var FigureLogoAnimation = function FigureLogoAnimation(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, _ref2, _ref3, _ref4);
};

export default FigureLogoAnimation;